// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__1OZCk","main":"Form_main__1uRFZ"};